import React from "react";
import {
  FinalIcon,
  StyledFinalContainer,
  StyledFinalH1,
  StyledText,
} from "./styled";
import { twoHappygranny } from "../../../../assets/images/Icon";

const Final = () => {
  return (
    <StyledFinalContainer>
      <StyledFinalH1>Merci de votre confiance !</StyledFinalH1>
      <StyledText>
        Nous vous affectons actuellement un conseiller dédié afin de vous aider
        à trouver les aides à domicile qui conviennent à tous vos critères.
        <br />
        Ce service est intégralement gratuit.{" "}
      </StyledText>
      <StyledText>
        Si votre demande est urgente, contactez directement le 09.78.45.01.71
      </StyledText>{" "}
      <StyledText
        style={{
          width: "83%",
        }}
      >
        Merci !
      </StyledText>
      <FinalIcon src={twoHappygranny} alt="final icon" />
    </StyledFinalContainer>
  );
};

export default Final;
